/**
 * Upload API - Auto-generated typed wrapper.
 * DO NOT EDIT - Regenerate with: bun run generate
 * @generated
 */

import { uploadImage } from "../generated/upload/upload";

import { wrapMethod } from "./utils";

export const upload = {
  /** @see uploadImage */
  uploadImage: wrapMethod(uploadImage),
} as const;

export type UploadApi = typeof upload;
